export enum GlobalStyleClass {
  DIALOG_SIZE_LIMIT = 'dialog-size-limit',
  DIALOG_INCREASE_SIZE = 'dialog-increase-size'
}
